import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-slate-950 py-12 border-t border-slate-900" data-id="element-66">
        <div className="container mx-auto px-4 text-center text-slate-600 text-sm" data-id="element-67">
          <p className="mb-4" data-id="element-68">
            &copy; {new Date().getFullYear()} Protocolo Noche Tranquila 65+.
            Todos los derechos reservados.
          </p>
          <p className="mb-6" data-id="element-69">
            Este producto no sustituye el consejo médico profesional. Siempre
            consulta a un especialista.
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-70">
            <button onClick={() => setShowPrivacy(true)} className="text-slate-500 hover:text-amber-400 transition-colors underline underline-offset-2" data-id="element-71">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-72">•</span>
            <button onClick={() => setShowTerms(true)} className="text-slate-500 hover:text-amber-400 transition-colors underline underline-offset-2" data-id="element-73">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-74">
        <p data-id="element-75">
          <strong data-id="element-76">Última actualización:</strong> Febrero 2026
        </p>
        <p data-id="element-77">
          En Protocolo Noche Tranquila 65+ nos comprometemos a proteger tu
          privacidad. Esta política describe cómo recopilamos, usamos y
          protegemos tu información personal.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-78">
          1. Información que recopilamos
        </h3>
        <p data-id="element-79">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. No
          almacenamos información de tarjetas de crédito directamente; los pagos
          son procesados por plataformas seguras de terceros.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-80">
          2. Uso de la información
        </h3>
        <p data-id="element-81">
          Tu información se utiliza exclusivamente para: entregar el producto
          digital adquirido, enviar actualizaciones relacionadas con tu compra y
          brindarte soporte al cliente si lo solicitas.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-82">
          3. Protección de datos
        </h3>
        <p data-id="element-83">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-84">
          4. Compartir información
        </h3>
        <p data-id="element-85">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto los proveedores de servicios necesarios para
          procesar pagos y entregar el producto.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-86">5. Tus derechos</h3>
        <p data-id="element-87">
          Puedes solicitar la eliminación de tus datos personales en cualquier
          momento enviando una solicitud a nuestro equipo de soporte.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-88">
        <p data-id="element-89">
          <strong data-id="element-90">Última actualización:</strong> Febrero 2026
        </p>
        <p data-id="element-91">
          Al adquirir el Protocolo Noche Tranquila 65+, aceptas los siguientes
          términos y condiciones de uso.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-92">1. Producto digital</h3>
        <p data-id="element-93">
          El Protocolo Noche Tranquila 65+ es un producto digital (PDF +
          materiales imprimibles) que se entrega por correo electrónico
          inmediatamente después de la compra. No es un servicio médico ni
          sustituye la consulta profesional.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-94">2. Uso personal</h3>
        <p data-id="element-95">
          El contenido adquirido es para uso personal y familiar. Queda
          prohibida su reproducción, distribución o reventa sin autorización
          expresa.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-96">
          3. Garantía de devolución
        </h3>
        <p data-id="element-97">
          Ofrecemos una garantía de satisfacción de 14 días. Si no estás
          conforme con el producto, puedes solicitar un reembolso completo
          dentro de los 14 días posteriores a la compra, sin preguntas.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-98">
          4. Descargo de responsabilidad
        </h3>
        <p data-id="element-99">
          Este producto tiene fines educativos e informativos. No pretende
          diagnosticar, tratar ni curar ninguna condición médica. Siempre
          consulta a un profesional de la salud antes de realizar cambios en la
          rutina de sueño de una persona mayor.
        </p>
        <h3 className="text-white font-semibold mt-4" data-id="element-100">5. Modificaciones</h3>
        <p data-id="element-101">
          Nos reservamos el derecho de actualizar estos términos en cualquier
          momento. Los cambios serán efectivos desde su publicación.
        </p>
      </Modal>
    </>;
}